import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { requestPasswordReset } from '../remote';

const ForgotPassword: React.FC = () => {
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const navigate = useNavigate();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    const trimmed = identifier.trim();
    if (!trimmed) {
      setError('Please enter your email or username.');
      return;
    }
    setLoading(true);
    try {
      const payload: any = trimmed.includes('@') ? { email: trimmed } : { username: trimmed };
      const resp = await requestPasswordReset(payload);
      const data = (resp as any) || {};
      if ((data as any).uid && (data as any).token) {
        setSuccess('Reset token generated. Proceeding to set new password...');
        // In this dev flow, redirect to reset page with uid and token in query
        setTimeout(() => {
          navigate(`/auth/reset-password?uid=${encodeURIComponent(data.uid)}&token=${encodeURIComponent(data.token)}`);
        }, 800);
      } else if ((resp as any)?.response?.data?.detail) {
        setSuccess((resp as any).response.data.detail);
      } else if ((data as any)?.detail) {
        setSuccess((data as any).detail);
      } else {
        setSuccess('If an account exists, reset instructions have been sent.');
      }
    } catch (e: any) {
      setError(e?.response?.data?.detail || e?.message || 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rounded-sm border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
      <h2 className="mb-6 text-2xl font-bold text-black dark:text-white">Forgot Password</h2>
      {error && <div className="mb-4 rounded border border-red-300 bg-red-50 p-3 text-red-700">{error}</div>}
      {success && <div className="mb-4 rounded border border-green-300 bg-green-50 p-3 text-green-700">{success}</div>}
      <form onSubmit={onSubmit}>
        <label className="mb-2.5 block font-medium text-black dark:text-white">Email or Username</label>
        <input
          type="text"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          placeholder="Enter your email or username"
          className="mb-4 w-full rounded-lg border border-stroke bg-transparent p-3 text-black outline-none focus:border-primary dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
        />
        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-lg border border-primary bg-primary p-3 text-white transition hover:bg-opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? 'Sending…' : 'Send reset link'}
        </button>
        <div className="mt-4 text-center">
          <Link className="text-primary" to="/login">Back to login</Link>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
